import * as yup from "yup";
import "yup-phone";

interface RCI3ValidationSchemaProps {
  languageSpecialization: boolean;
}

const RCI3ValidationSchema = ({
  languageSpecialization,
}: RCI3ValidationSchemaProps) => {
  let schema = yup.object().shape({
    name: yup.string().max(60, "Name cannot exceed 60 characters"),
    telephone: yup.string().matches(/^(\d{10})?$/, "Invalid phone number , number must be 10 digits"),
    website: yup.string().url("Website must be valid"),
    stateLegal: yup.string().max(1000, "Max character limit reached"),
    responsibilityReporting: yup
      .string()
      .max(1000, "Max character limit reached"),
    stateLegalBilingual: yup.string(),
    responsibilityReportingBiligual: yup.string(),
  });

  const secondLanguageFields = {
    stateLegalBilingual: yup.string().max(1000),
    responsibilityReportingBiligual: yup.string().max(1000),
  };

  if (languageSpecialization) {
    schema = schema.shape(secondLanguageFields);
  }

  return schema;
};

export default RCI3ValidationSchema;
